export * from './formular-kopiert.interface';
